/* tslint:disable */
/* eslint-disable */
/**
 * ROC API
 * Referral Outbound Center (ROC) API for managing outbound referrals between post-acute care facilities.  All endpoints require a valid JWT. Organization and user identity are derived from the token — callers never pass these in query params or request bodies. 
 *
 * The version of the OpenAPI document: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RecipientStatus } from './RecipientStatus';
import {
    RecipientStatusFromJSON,
    RecipientStatusFromJSONTyped,
    RecipientStatusToJSON,
    RecipientStatusToJSONTyped,
} from './RecipientStatus';

/**
 * 
 * @export
 * @interface RecipientReferralViewRecipient
 */
export interface RecipientReferralViewRecipient {
    /**
     * 
     */
    facility_id: string;
    /**
     * 
     */
    facility_name?: string | null;
    /**
     * 
     */
    status: RecipientStatus;
}



/**
 * Check if a given object implements the RecipientReferralViewRecipient interface.
 */
export function instanceOfRecipientReferralViewRecipient(value: object): value is RecipientReferralViewRecipient {
    if (!('facility_id' in value) || value['facility_id'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function RecipientReferralViewRecipientFromJSON(json: any): RecipientReferralViewRecipient {
    return RecipientReferralViewRecipientFromJSONTyped(json, false);
}

export function RecipientReferralViewRecipientFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecipientReferralViewRecipient {
    if (json == null) {
        return json;
    }
    return {
        
        'facility_id': json['facility_id'],
        'facility_name': json['facility_name'] === undefined ? undefined : json['facility_name'] === null ? null : json['facility_name'],
        'status': RecipientStatusFromJSON(json['status']),
    };
}

export function RecipientReferralViewRecipientToJSON(json: any): RecipientReferralViewRecipient {
    return RecipientReferralViewRecipientToJSONTyped(json, false);
}

export function RecipientReferralViewRecipientToJSONTyped(value?: RecipientReferralViewRecipient | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'facility_id': value['facility_id'],
        'facility_name': value['facility_name'],
        'status': RecipientStatusToJSON(value['status']),
    };
}

